export default "__VITE_ASSET__DwjGjLcR__"